module.exports = __webpack_public_path__ + "img/customer3.3bdf5ed1.jpg";